import { Button, Form, Select, Table, Tag } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import styles from "../styles/Content.module.css";
import { useState } from "react";

const TopProducts = ({ branches, products, isAdmin }) => {
  const [locationSelected, handleLocationSelected] = useState(null);

  const filterByBranch = ({ location }) => {
    handleLocationSelected(location);
  };

  const mapData = () => {
    if (!locationSelected) {
      return products;
    }
    const productsByBranch = products.filter(
      (item) => item.id === locationSelected
    );
    return productsByBranch;
  };

  const columns = [
    {
      title: "Sucursal",
      dataIndex: "branch",
      key: "branch",
      render: (val) => <Tag color="orange">{val}</Tag>,
    },
    {
      title: "Posición",
      dataIndex: "quantity",
      key: "position",
      align: "center",
      width: 100,
      render: (_, __, index) => (
        <span style={{ fontWeight: 600, color: '#888' }}>#{index + 1}</span>
      ),
    },
    {
      title: "Producto",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      render: (val) => <span style={{ fontWeight: 600, color: 'var(--orange)' }}>{val}</span>,
    },
  ];

  return (
    <div className={styles.cardContent}>
      {isAdmin && (
        <div className={styles.filterForm}>
          <Form layout="inline" onFinish={filterByBranch}>
            <Form.Item name="location">
              <Select
                className={styles.select}
                placeholder="Todas las sucursales"
                showSearch
                optionFilterProp="label"
                options={branches.map((item) => {
                  return { value: item.id, label: item.zone };
                })}
                allowClear
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" icon={<FilterOutlined />} style={{ display: 'inline-flex', alignItems: 'center' }}>
              Filtrar
            </Button>
          </Form>
        </div>
      )}

      <Table
        columns={columns}
        dataSource={mapData()}
        rowKey={(_, idx) => idx}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        scroll={{ x: 'max-content' }}
        size="middle"
        style={{ borderRadius: '14px', overflow: 'hidden' }}
      />
    </div>
  );
};

export default TopProducts;
